(function () {
    "use strict";

    angular.module('downloadCenterApp', [
        'downloadService',
        'alertService',
        'documentService',
        'appDirectives',
        'angular.filter',
        'ngSanitize',
        'ng.deviceDetector',
        'typeahead',
        'ngDialog'
    ]);
}());
